<template>
    <div class="included-parts">
        <div class="heading" @click="toggleIncludedExpanded()">
            <span>{{ items.length }} {{ label_included_parts }}</span>
            <i :class="[includedExpanded ? 'icon icon-minus' : 'icon icon-plus']"></i>
        </div>
        <div class="included-part-items" v-if="includedExpanded">
            <div class="item" v-for="(product, index) in items" :key="index">
                <div class="image">
                    <img width="175" :src="product.image" alt />
                </div>
                <div class="name">
                    <a :href="product.url">{{ product.title }}</a>
                    <div class="code">{{ product.stockCode }}</div>
                </div>
                <div class="spacer"></div>
                <div class="price">
                    <div class="title">{{ label_price }}</div>
                    <div class="label">{{ product.productPrice }}</div>
                </div>
                <div class="quantity">
                    <div class="title">{{ label_qty }}</div>
                    <div class="label">x{{ product.quantity }}</div>
                </div>
        </div>
    </div>
    </div>
</template>

<script>
import { filter } from "minimatch";
export default {
    name: "product-component",
    props: {
        items: {
            type: Array
        },
        currency_suffix: {
            type: String,
            default: ""
        },
        label_total: {
            type: String,
            required: true,
            default: "Total"
        },
        label_price: {
            type: String,
            required: true,
            default: "Price"
        },
        label_qty: {
            type: String,
            required: true,
            default: "Qty"
        },
        label_included_parts: {
            type: String,
            required: true,
            default: "included parts"
        }
    },
    data() {
        return {
            includedExpanded: false
        }
    },
    methods: {
        currencyFormat(num) {
            return num;
        },
        toggleIncludedExpanded() {
            this.includedExpanded = !this.includedExpanded;
        },
    },
    computed: {
        filteredItems() {
            let filtered = [];
            this.items.forEach(item => {
                if (item.quantity > 0) {
                    filtered.push(item);
                }
            });

            return filtered;
        }
    }
};
</script>
